import {useEffect} from "react"
import {useSignal} from "@preact/signals-react"
import {useAppToast} from "@ui-seeker/app"
import {getSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants"

/**
 * Hook to fetch all mappers statistics for admin dashboard
 * 
 * Expected API response format:
 * [
 *   {
 *     username: "john.doe@example.com",
 *     pendingMappings: 25,
 *     totalMappings: 1500,
 *     last7DaysMappings: 120,
 *     avgMappingsPerDay: 17.1,
 *     totalEarnings: 22.5,
 *     external: 1  // 1 = external user (shows earnings), 0 = internal user
 *   },
 *   ...
 * ]
 */
export default function useMappersStats() {
	const { showToast } = useAppToast()
	
	const isLoading = useSignal(true)
	const mappersData = useSignal([])

	const fetchMappersStats = () => {
		isLoading.value = true
		getSubmit(`${BACKEND_APIS.MATCHERS}/stats/all-mappers`)
			.then(res => {
				if (res) {
					mappersData.value = res || []
				}
			})
			.catch(() => showToast.error('Error loading mappers statistics'))
			.finally(() => {
				isLoading.value = false
			})
	}

	useEffect(() => {
		fetchMappersStats()
	}, [])

	return {
		isLoading: isLoading.value,
		mappersData: mappersData.value,
		refreshStats: fetchMappersStats
	}
}
